"use client";

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname, useParams } from 'next/navigation';
import { useLanguage } from '@/context/LanguageContext';

export default function FloatingFeedback() {
  const pathname = usePathname();
  const params = useParams();
  const lang = (params?.lang as string) || 'en';
  const { language } = useLanguage();
  const [mounted, setMounted] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  // Don't show floating widget if already on the feedback page
  if (pathname && pathname.includes('/feedback')) {
    return null;
  }

  return (
    <div
      className="hide-on-mobile"
      style={{
        position: 'fixed',
        right: 0,
        top: '52%',
        transform: `translateY(-50%) translateX(${isHovered ? '-3px' : '0px'})`,
        zIndex: 9999,
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link
        href={`/${lang}/feedback`}
        title={language === 'sq' ? 'Dërgoni Sugjerim ose Pyetje' : 'Send Feedback or Suggestion'}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.25rem',
          background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)',
          color: 'white',
          padding: '0.5rem 0.65rem 0.5rem 0.55rem',
          borderRadius: '10px 0 0 10px',
          boxShadow: isHovered
            ? '0 8px 25px rgba(37, 99, 235, 0.45), 0 2px 6px rgba(0, 0, 0, 0.1)'
            : '0 4px 14px rgba(37, 99, 235, 0.3), 0 1px 3px rgba(0, 0, 0, 0.08)',
          textDecoration: 'none',
          cursor: 'pointer',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRight: 'none',
          fontWeight: 600,
          fontSize: '0.72rem',
          letterSpacing: '0.02em',
          userSelect: 'none',
          textAlign: 'center'
        }}
      >
        <span style={{ fontSize: '1rem', lineHeight: 1 }}>💬</span>
        <span style={{ whiteSpace: 'nowrap', lineHeight: 1.1 }}>
          {language === 'sq' ? 'Sugjerime' : 'Feedback'}
        </span>
      </Link>
    </div>
  );
}
